import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "system-panel" }
const _hoisted_2 = { class: "system-tabs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemTabGeral = _resolveComponent("SystemTabGeral")!
  const _component_SystemTabPresencas = _resolveComponent("SystemTabPresencas")!
  const _component_SystemTabAtividades = _resolveComponent("SystemTabAtividades")!
  const _component_SystemTabOffline = _resolveComponent("SystemTabOffline")!
  const _component_SystemTabCoresRelatorios = _resolveComponent("SystemTabCoresRelatorios")!
  const _component_SystemTabFuso = _resolveComponent("SystemTabFuso")!
  const _component_SystemTabArmazenamento = _resolveComponent("SystemTabArmazenamento")!
  const _component_SystemTabRecursos = _resolveComponent("SystemTabRecursos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["system-tab", { active: _ctx.activeTab === 'geral' }]),
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'geral'))
      }, "Geral", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["system-tab", { active: _ctx.activeTab === 'presencas' }]),
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'presencas'))
      }, "Presenças", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["system-tab", { active: _ctx.activeTab === 'atividades' }]),
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'atividades'))
      }, "Log de atividades", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["system-tab", { active: _ctx.activeTab === 'offline' }]),
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'offline'))
      }, "Tempo Offline", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["system-tab", { active: _ctx.activeTab === 'relatorios' }]),
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 'relatorios'))
      }, "Cores dos relatórios", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["system-tab", { active: _ctx.activeTab === 'fuso' }]),
        type: "button",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'fuso'))
      }, "Fuso horário", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["system-tab", { active: _ctx.activeTab === 'armazenamento' }]),
        type: "button",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeTab = 'armazenamento'))
      }, "Armazenamento", 2),
      (_ctx.isMasterAdmin)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["system-tab", { active: _ctx.activeTab === 'recursos' }]),
            type: "button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeTab = 'recursos'))
          }, "Recursos", 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.activeTab === 'geral')
      ? (_openBlock(), _createBlock(_component_SystemTabGeral, {
          key: 0,
          form: _ctx.form,
          "error-text": _ctx.errorText,
          "success-text": _ctx.successText,
          onUpdateForm: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update-form', $event))),
          onSave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('save')))
        }, null, 8, ["form", "error-text", "success-text"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'presencas')
      ? (_openBlock(), _createBlock(_component_SystemTabPresencas, {
          key: 1,
          form: _ctx.form,
          "error-text": _ctx.errorText,
          "success-text": _ctx.successText,
          onUpdateForm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update-form', $event))),
          onSave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('save')))
        }, null, 8, ["form", "error-text", "success-text"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'atividades')
      ? (_openBlock(), _createBlock(_component_SystemTabAtividades, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'offline')
      ? (_openBlock(), _createBlock(_component_SystemTabOffline, {
          key: 3,
          form: _ctx.form,
          "error-text": _ctx.errorText,
          "success-text": _ctx.successText,
          onUpdateForm: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update-form', $event))),
          onSave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('save')))
        }, null, 8, ["form", "error-text", "success-text"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'relatorios')
      ? (_openBlock(), _createBlock(_component_SystemTabCoresRelatorios, {
          key: 4,
          form: _ctx.form,
          "error-text": _ctx.errorText,
          "success-text": _ctx.successText,
          onUpdateForm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('update-form', $event))),
          onSave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('save')))
        }, null, 8, ["form", "error-text", "success-text"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'fuso')
      ? (_openBlock(), _createBlock(_component_SystemTabFuso, {
          key: 5,
          form: _ctx.form,
          "error-text": _ctx.errorText,
          "success-text": _ctx.successText,
          onUpdateForm: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('update-form', $event))),
          onSave: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('save')))
        }, null, 8, ["form", "error-text", "success-text"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'armazenamento')
      ? (_openBlock(), _createBlock(_component_SystemTabArmazenamento, { key: 6 }))
      : _createCommentVNode("", true),
    (_ctx.isMasterAdmin && _ctx.activeTab === 'recursos')
      ? (_openBlock(), _createBlock(_component_SystemTabRecursos, {
          key: 7,
          form: _ctx.form,
          "error-text": _ctx.errorText,
          "success-text": _ctx.successText,
          onUpdateForm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('update-form', $event))),
          onSave: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('save')))
        }, null, 8, ["form", "error-text", "success-text"]))
      : _createCommentVNode("", true)
  ]))
}